export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total to Deduct"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commission"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To Enrollment"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unable to calculate amount"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insufficient funds for payment"])}
}